module.exports = __webpack_public_path__ + "img/doodle.9538ad95.png";